import { useState } from 'react'
import { Check } from 'lucide-react'
import { Button } from '../../../core/index.js'

interface ReasonFormProps {
  label: string
  onSubmit: (reasonCode: string) => void
  pending: boolean
  onCancel: () => void
}

/** A reason code, asked inline: the run short and an assignment that passes a month rule both need one. */
export function ReasonForm({ label, onSubmit, pending, onCancel }: ReasonFormProps) {
  const [reason, setReason] = useState('')
  return (
    <form
      className="flex flex-wrap items-center gap-2"
      onSubmit={(event) => {
        event.preventDefault()
        if (reason.trim() !== '') {
          onSubmit(reason.trim().toUpperCase().replaceAll(' ', '_'))
        }
      }}
    >
      <label className="text-[10px] font-bold uppercase tracking-wide text-ink-mid">
        Reason code
        <input className="ml-2 w-40 rounded border border-marine/30 px-2 py-1 text-xs font-bold text-ink" value={reason} onChange={(event) => setReason(event.target.value)} placeholder="CENSUS_OK" autoFocus />
      </label>
      <Button type="submit" icon={Check} size="sm" busy={pending} disabled={reason.trim() === ''}>
        {pending ? 'Saving…' : label}
      </Button>
      <button type="button" className="text-xs font-bold text-ink-mid hover:text-ink" onClick={onCancel}>
        Cancel
      </button>
    </form>
  )
}
